import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const RoleProtectedRoute = ({ children, requiredRole }) => {
  const { user, isAuthenticated } = useSelector(state => state.auth);
  if (!isAuthenticated) return <Navigate to='/' />;
  if (user?.role !== requiredRole) return <Navigate to='/unauthorized' />;
  return children;
};

export default RoleProtectedRoute; 